<template>
  <div>
    <AgencyFilters :page="page" @reset-page="page = 1" />
    <AgenciesTable />
    <el-pagination
      v-if="pageCount > 1"
      background
      prev-text="Previous"
      next-text="Next"
      :page-size="pageSize"
      :pager-count="5"
      layout="prev, pager, next"
      :current-page.sync="page"
      class="text-center mt-20"
      :page-count="pageCount"
    />
  </div>
</template>

<script>
import agencyAccess from '@/components/Agencies/agencyAccess';
import AgencyFilters from '@/components/Agencies/AgencyFilters';
import AgenciesTable from '@/components/Agencies/AgenciesTable';
import { mapState } from 'vuex';

export default {
  mixins: [agencyAccess],
  components: {
    AgencyFilters,
    AgenciesTable,
  },
  data: () => ({
    page: 1,
    pageSize: 20,
  }),
  created() { this.$store.dispatch('agencies/refreshPermissions'); },
  computed: {
    ...mapState('agencies', ['agenciesMeta']),
    pageCount() {
      return this.agenciesMeta['total_page'] || 0;
    },
  },
};
</script>
